
<div class="row" *ngIf="isDeploymentRejected">
  <div class="col">
    <div class="alert alert-danger"><span>This deployment has been rejected for the following reason: {{ rejectedReason }}<span *ngIf="allowUnRejectDeployment">
          <button class="btn btn-sm float-right btn-outline-dark" type="button" style="margin-top: -0.25em;" (click)="removeDeploymentRejection()">Remove Deployment Rejection</button></span></span></div>
  </div>
</div>